/**
 * BookingSummary — Compact booking summary bar for hotels flavor.
 *
 * Shows: Room name · N nights · N guests · Total price
 * Hidden when no booking exists. Parallel to CartSummary (ecommerce)
 * but with hotel-specific fields.
 */
export class BookingSummary {
  constructor() {
    this.element = null;
    this.booking = null;
  }

  render() {
    const el = document.createElement('div');
    el.className = 'ttp-booking-summary ttp-booking-empty';
    el.style.display = 'none';

    el.innerHTML = `
      <div class="ttp-booking-info">
        <span class="ttp-booking-icon">\uD83C\uDFE8</span>
        <span class="ttp-booking-room">No booking</span>
        <span class="ttp-booking-sep">\u00B7</span>
        <span class="ttp-booking-stay"></span>
        <span class="ttp-booking-sep">\u00B7</span>
        <span class="ttp-booking-total"></span>
      </div>
    `;

    this.element = el;
    return el;
  }

  update(booking) {
    this.booking = booking;
    if (!this.element) return;

    if (!booking || !booking.roomName) {
      this.element.style.setProperty('display', 'none', 'important');
      this.element.classList.add('ttp-booking-empty');
      return;
    }

    this.element.style.setProperty('display', 'flex', 'important');
    this.element.classList.remove('ttp-booking-empty');

    const sym = booking.currency === 'ILS' ? '\u20AA' : (booking.currency === 'EUR' ? '\u20AC' : '$');
    const nights = booking.nights || 1;
    const guests = booking.guests || 1;
    const total = booking.totalPrice || (booking.pricePerNight * nights);

    this.element.querySelector('.ttp-booking-room').textContent = booking.roomName;
    this.element.querySelector('.ttp-booking-stay').textContent =
      `${nights} night${nights !== 1 ? 's' : ''} \u00B7 ${guests} guest${guests !== 1 ? 's' : ''}`;
    this.element.querySelector('.ttp-booking-total').textContent = `${sym}${total.toFixed(0)}`;
  }

  hide() {
    if (this.element) {
      this.element.style.setProperty('display', 'none', 'important');
      this.element.classList.add('ttp-booking-empty');
    }
    this.booking = null;
  }

  static generateCSS() {
    return `
/* ═══════════════════════════════════════
   BOOKING SUMMARY
   ═══════════════════════════════════════ */

.ttp-booking-summary {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: rgba(109,86,245,0.08);
  border: 1px solid rgba(109,86,245,0.15);
  border-radius: 10px;
  margin: 6px 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.ttp-booking-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  font-weight: 500;
  flex-wrap: wrap;
}

.ttp-booking-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.ttp-booking-room {
  font-weight: 600;
  color: #e8e4f0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.ttp-booking-sep {
  color: rgba(255,255,255,0.2);
}

.ttp-booking-stay {
  white-space: nowrap;
  color: rgba(255,255,255,0.5);
}

.ttp-booking-total {
  font-weight: 700;
  color: #a78bfa;
}

.ttp-booking-empty {
  display: none !important;
}
`;
  }
}
